import React, {Component} from 'react'
import PaperBlock from '../../ui/PaperBlock'

import {List, ListItem} from '@material-ui/core'

/**
 * shops - список магазинов {id, name}.
 * selected - выбранный магазин.
 * onShopClick(shop) - сработает по клику по магазину.
 * onShopDoubleClick(shop) - двойной клик по магазину.
 */

class ShopList extends Component {

    render() {
        let shops = this.props["shops"] ? this.props["shops"] : []
        return <PaperBlock>
            <List>
                {shops.map((shop, n) => {
                    return <ListItem 
                        key={n}
                        button
                        selected = {this.props.selected ? this.props.selected["id"] === shop["id"] : false}
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onShopClick === "function") {
                                this.props.onShopClick(shop)
                            }
                        }}
                        onDoubleClick={e => {
                            e.stopPropagation()
                            if (typeof this.props.onShopDoubleClick === "function") {
                                this.props.onShopDoubleClick(shop)
                            }
                        }}
                    >
                        {shop["name"]}
                    </ListItem>
                })}
            </List>
        </PaperBlock>
    }

}

export default ShopList